import React, { Component } from 'react';
import './App.css';
import ChatBot from 'react-simple-chatbot';
import { steps } from './bot/steps';
import { ThemeProvider } from 'styled-components';
import EncuestaModal from './bot/EncuestaModal';

const theme = {
  background: '#f5f8fb',
  fontFamily: 'Helvetica',
  headerBgColor: '#004b87',
  headerFontColor: '#fff',
  headerFontSize: '15px',
  botBubbleColor: '#004b87',
  botFontColor: '#fff',
  userBubbleColor: '#3386d8',
  userFontColor: '#fff'
};

const ChatHeader = ({ onOpenModal, onClose }) => (
  <div style={{
    backgroundColor: '#004b87',
    color: '#fff',
    padding: '10px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '15px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px'
  }}>
    <span style={{ fontSize: '16px', fontWeight: 'bold' }}>Asistente VeniAI</span>
    <div>
      <button
        onClick={onOpenModal}
        style={{
          backgroundColor: 'transparent',
          color: '#fff',
          border: 'none',
          fontSize: '20px',
          cursor: 'pointer',
          marginRight: '10px'
        }}
        title="Evaluar satisfacción"
      >
        😊
      </button>
      <button
        onClick={onClose}
        style={{
          backgroundColor: 'transparent',
          color: '#fff',
          border: 'none',
          fontSize: '18px',
          cursor: 'pointer'
        }}
        title="Cerrar chat"
      >
        ✖
      </button>
    </div>
  </div>
);

const ChatFooter = () => (
  <div style={{
    textAlign: 'center',
    padding: '8px',
    fontSize: '11px',
    color: 'rgb(129, 129, 129)',
    borderTop: '1px solid #ddd',
    background: '#ffffff',
    borderBottomLeftRadius: '10px',
    borderBottomRightRadius: '10px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginTop: '-6px'
  }}>
    La IA puede generar información inexacta
  </div>
);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showChat: false
    };
  }

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleToggleChat = () => {
    this.setState((prev) => ({ showChat: !prev.showChat }));
  };

  render() {
    return (
      <div
        style={{
          position: 'relative',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          overflow: 'hidden',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >

        {/* <img
          src="/02-mesa-de-ayuda.png"
          alt="Header"
          style={{ maxWidth: '350px', marginBottom: '10px' }}
        /> */}

        {/* Botón flotante personalizado */}
        {!this.state.showChat && (
          <button
            onClick={this.handleToggleChat}
            style={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: '#004b87',
              color: '#fff',
              fontSize: '28px',
              border: 'none',
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
            }}
          >
            💬
          </button>
        )}

        {/* Contenedor del chat */}
        {this.state.showChat && (
          <div style={{
            position: 'fixed',
            bottom: '30px',
            right: '20px',
            width: '350px',
            borderRadius: '10px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            backgroundColor: '#fff',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <ChatHeader
              onOpenModal={this.handleOpenModal}
              onClose={this.handleToggleChat}
            />

            <ThemeProvider theme={theme}>
              <ChatBot
                steps={steps}
                hideHeader={true}
                botAvatar="https://www.uaem.mx/chatbot/01_veni.jpg"
                userAvatar="https://www.uaem.mx/chatbot/user-avatar.png"
                placeholder="Escribe aquí..."
                style={{ width: '100%' }}
              />
            </ThemeProvider>

            <ChatFooter />
          </div>
        )}
{/* 
        <img
          src="/03-coordinacion.png"
          alt="Footer"
          style={{ maxWidth: '348px', marginTop: '800px' }}
        /> */}

        {this.state.showModal && <EncuestaModal onClose={this.handleCloseModal} />}
      </div>
    );
  }
}

export default App;
